import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import CommonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { setPassportInfo } from "../../../const/RTCC";
import messageConst from "../../../const/RTCC/messageConst";
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { ConfirmPassportList } from "../../molecules/RTCC/confirmPassportList";
import { ErrorMassage } from "../../molecules/RTCC/errorMassage";
import './../../../resources/RTCC/css/passport/passport.css';
import { FooterContainer } from './footerContainer';

const RtccInputPassportConfirmContainer = (props) => {
    const {
        login,
        toUserInputInfo,
        passportInfo,
        setToUserInputInfo,
        onChange } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);
    const [roomNum, setRoomNum] = useState(toUserInputInfo.roomNum);
    const [represent, setRepresent] = useState({
        roomCount: "",
        guestSeq: "",
        guestNameRoman: "",
        passportNumber: "",
        issueDate: "",
        validDate: ""
    });
    const [accompanyList, setAccompanyList] = useState([]);

    const [errorInfo, setErrorInfo] = useState({
        errorMessage: null,
        errorFlg: false,
    });

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        setToUserInputInfo(toUserInputInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }, { path: "/reserve/rtcc/inputPassport", label: "パスポート情報入力" }]);
        setRepresent(passportInfo.represent);
        setAccompanyList(passportInfo.accompanyList);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/rtcc/inputPassport");
    }
    // 登録ボタン押下時
    const onClickCheckInput = () => {
        let list = [];
        let errFlg = false;
        if (represent.issueDate == false || represent.validDate == false || CommonValidation.Require(represent.passportNumber)) {
            errFlg = true;
        }
        accompanyList.forEach((value) => {
            if (CommonUtil.convPassportDate(value.issueDate, true) == false || CommonUtil.convPassportDate(value.validDate, true) == false || CommonValidation.Require(value.passportNumber)) {
                errFlg = true;
            }
        })
        passportInfo.passportInfoList.map((value, index) => {
            let passportInfoObj = {
                roomCount: value.roomCount,
                guestSeq: value.guestSeq,
                guestNameRoman: value.guestNameRoman,
                passportNumber: value.passportNumber,
                issueDate: CommonUtil.convPassportDate(value.issueDate, true),
                validDate: CommonUtil.convPassportDate(value.validDate, true)
            };
            list.push(passportInfoObj);
        })
        if (errFlg) {
            setErrorInfo({
                errorMessage: [messageConst.INPUT_ERROR],
                errorFlg: errFlg
            });
        } else {
            common.doPost(setPassportInfo, { reserveId: toUserInputInfo.reserveId, passportInfo: list, loginId: login.memberCode }, afterSetPassportInfo);
        }
    }
    const afterSetPassportInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            history.push("/reserve/rtcc/inputPassportComplete");
        }
    }

    // 変更ボタン
    const handleEdit = (form) => {
        history.push("/reserve/rtcc/inputPassport")
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="入力内容確認"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div className="passportErrConirmWrapper">
                    <div style={errorInfo.errorFlg ? styles.errorDiv: { display: "none" }}>
                        <ErrorMassage data={errorInfo.errorMessage} />
                    </div>
                <div className="reserveContentWrapper">
                    <Label label="ご予約内容" className="reserveConirmTitle2" />
                    <div className="reservationContentsWrap">
                        <div className="reservationContents">
                            <Label
                                label="ご利用日程"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.startDate + "\n" + "～" + "\n" + toUserInputInfo.endDate}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="施設名"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.hotelName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="お部屋タイプ"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.roomType}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="予約番号"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.reserveId}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* パスポート情報入力フォーム */}
            <ConfirmPassportList
                representData={represent}
                accompanyList={accompanyList}
                titleClassName="reserveConirmTitle"
                handleEdit={handleEdit}
                responsiveFlg={isWideTablet}
            />
            <div className="btnPassportToConfirmWrapper">
                <div className="confirmboxWrap">
                    <Button buttonText="戻る" className="btnBack" onClick={onClickBack} buttonClassName="serachBtnText" />
                    <Button buttonText="この内容で登録する" className="btnReserve" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                </div>
                <div className="flightToTop">
                    <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        checkIn: state.checkIn,
        passportInfo: state.passportInfo,
        toUserInputInfo: state.toUserInputInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setPassportInfo: (item) => {
            dispatch({ type: "PASSPORT_INFO", payload: { passportInfo: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccInputPassportConfirmContainer);

const styles = {
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    confirmbox: {
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexWrap: "wrap",
        padding: "30px 0px",
    },
    reservationInfoWrapper: {
        width: "90%",
        textAlign: "center",
        margin: "auto",
    },
    reservationInfo: {
        display: "flex",
        flexWrap: "wrap",
        textAlign: "left",
        margin: "auto",
        justifyContent: "center"
    },
    waveDash: {
        display: "flex",
        margin: "5px 0 5px 0px",
        justifyContent: "center"
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}